import { render, staticRenderFns } from "./AuthOtpComponent.vue?vue&type=template&id=099fe6bc&scoped=true"
import script from "./AuthOtpComponent.vue?vue&type=script&lang=js"
export * from "./AuthOtpComponent.vue?vue&type=script&lang=js"
import style0 from "./AuthOtpComponent.vue?vue&type=style&index=0&id=099fe6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099fe6bc",
  null
  
)

export default component.exports